import React, { useEffect, useState } from "react";

import { duration } from "@formant/core/model/duration";
import { FlexContent } from "@formant/ui/component/common/FlexContent";
import { LoadingIndicator } from "@formant/ui/component/common/LoadingIndicator";

import { NoDataMessage } from "../common/NoDataMessage";

export function LoadingChartIndicator() {
    const [noData, setNoData] = useState<boolean>(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setNoData(true);
        }, 10 * duration.second);
        return () => clearTimeout(timer);
    }, []);

    if (noData) {
        return (
            <NoDataMessage>
                <FlexContent
                    defaultPadding={100}
                    horizontalAlign="center"
                    verticalAlign="center"
                >
                    No Data Available. Try changing the time window or device(s)
                </FlexContent>
            </NoDataMessage>
        );
    }
    return <LoadingIndicator visible={true} />;
}
